import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Title from 'components/Title';
import { styleConstants } from 'theme/styleConstants';

const DESCRIPTION_ID = 'pending-media-description';

type PendingMediaNoticeProps = {
  onReload: () => void;
  onJoinWithoutMedia: () => void;
};

const PendingMediaNotice = ({ onReload, onJoinWithoutMedia }: PendingMediaNoticeProps) => {
  const { t } = useTranslation('join');

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: styleConstants.narrowContainerWidth,
        textAlign: 'center',
      }}
    >
      <Title>{t('pending_media.title')}</Title>
      <Typography id={DESCRIPTION_ID} sx={{ mb: 6 }}>
        {t('pending_media.description')}
      </Typography>
      <Button
        type="button"
        variant="contained"
        fullWidth
        aria-describedby={DESCRIPTION_ID}
        onClick={onReload}
      >
        {t('pending_media.btn_reload')}
      </Button>
      <Button
        type="button"
        variant="outlined"
        fullWidth
        sx={{ mt: 4 }}
        onClick={onJoinWithoutMedia}
      >
        {t('pending_media.btn_join_without_media')}
      </Button>
    </Box>
  );
};

export default PendingMediaNotice;
